// extracted by mini-css-extract-plugin
export var backdropBlur = "_is-0";
export var contentCard = "_is-5";
export var frame = "_is-2";
export var image = "_is-4";
export var imagePane = "_is-3";
export var modal = "_is-1";